import React from 'react';
import {
	Link
} from 'react-router-dom';

export default (props) => {

	let isAdmin = JSON.parse(localStorage.getItem("isAdmin")) || false;
	let isSuperman = JSON.parse(localStorage.getItem("isSuperman")) || false;

	const userOptions = [{
		'name': 'schedule',
		'route': '/schedule'
	}];

	const adminOptions = [{
		'name': 'buildings',
		'route': '/buildings'
	},
	{
		'name': 'floors',
		'route': '/floors'
	},
	{
		'name': 'rooms',
		'route': '/rooms'
	},
	{
		'name': 'resources',
		'route': '/resources'
	},
	{
		'name': 'users',
		'route': '/users'
	},
	{
		'name': 'search',
		'route': '/search'
	},
	];

	const supermanOptions = [{
		'name': 'accounts',
		'route': '/accounts'
	}];




	return (

		<ul className="tabs" data-active-collapse="true">
			{
				userOptions.map((e, index) => {
					let isActive = props.activeTab === e.name ? ' is-active' : "";
					return (
						<li key={index} className={"tabs-title " + e.name + isActive}>
							<Link to={e.route}>{e.name}</Link>
						</li>
					);
				})
			}
			{
				isAdmin ?
					adminOptions.map((e, index) => {
						let isActive = props.activeTab === e.name ? ' is-active' : "";
						return (
							<li key={index} className={"tabs-title " + e.name + isActive}>
								<Link to={e.route}>{e.name}</Link>
							</li>
						);
					}) : ""
			}

			{
				isSuperman ?
					supermanOptions.map((e, index) => {
						let isActive = props.activeTab === e.name ? ' is-active' : "";
						return (
							<li key={index} className={"tabs-title " + e.name + isActive}>
								<Link to={e.route}>{e.name}</Link>
							</li>
						);
					}) : ""
			}

		</ul>
	);
};



// WEBPACK FOOTER //
// ./src/Components/Tabbar/Tabs/index.js